import React from "react";
import { useState, useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import DefaultLandingPage from "../features/components/landing-page-group";
import Crani from "../components/layouts/HomePage";
import EntVideoPage from "../components/layouts/EntVideoPage";
import EntDemoPage from "../components/layouts/EntDemoPage";
import Custom404 from "../features/components/custom-404";
// import StartProjectGroupPage from "../features/components/start-project-group";
// import SpineStatic1 from "../features/spine/spine";
import Sealonix from "../features/spine/spine-static";
import GutLab from "../features/gutlab/gutlab";
import Liger from "../features/liger/liger";
import ContactThemeGenerate from "../features/components/color_theme";
import SpineStaticLegal from "../features/utahlegal/utahlegal";
import Login from "../userAuth/Login";
// import OtpVerify from "../userAuth/otp/OtpVerify";
import Loader from "../components/Loader/Loader";
import Layout from "../userAuth/mainLayout";
import PrivateRoute from "../userAuth/protectedRoute";
import ShareAnimation from "../users/shareAnimation";
import UserProfile from "../users/settings/profileSetings/userProfile";
import Rejoni from "../features/rejoni";
import RejoniPresentation from "../features/rejoni-presentation/rejoni";
import DefaultMessageSetting from "../users/settings/shareanimationSetings/defaultMessageSetting";
import ManagerUser from "../users/manageAccounts/manageUsers";
import Logout from "../userAuth/Login/logout";
import LoopSetting from "../users/animationloop/loopsetting";
import HomePage from "../users/dashboard/home/homePage.tsx";
// import Subscription from "../userAuth/Subscription/subcriptionPage.tsx";
import EmailTemplate from "../users/emailTemplate/email_template.tsx";
import ShortURLAnimationViewnew from "../features/animationView/animationViewnew.tsx";
import LigerFinal from "../features/liger/ligerFinalDelivery.tsx";
const LOCAL_SHORT_URL = import.meta.env.VITE_LOCAL_SHORT_URL;
import PlayLoop from "../users/animationloop/loopvideo.tsx";
import ManageLocation from "../users/manageAccounts/manageLocations/manageLocation.tsx";
import UsageReport from "../users/reports/usageReports.tsx";
import ManageLocationsClass from "../users/manageAccounts/manageLocationclass/managelocationsclass.tsx";
import ManageFavourites from "../users/manageAccounts/manageFavourites/manageFavourites.tsx";
import SharedAnimationReport from "../users/reports/sharedAnimationReport.tsx";
import ResetPassword from "../userAuth/Resetpassword/resetPassword.tsx";
import Favorites from "../users/favorites/favorites.tsx";
// import SignUp from "../features/components/sign-up";
// import ContactUs from "../features/contact-us/contact-us";
// import AboutUs from "../features/components/about_us.tsx";
import PreloginAboutUs from "../PreloginComponent/Layout/AboutUs.tsx";
import PreloginContact from "../PreloginComponent/Layout/ContactUs.tsx";
import Signup from "../PreloginComponent/Layout/Signup.tsx";
import PreloginServices from "../PreloginComponent/Layout/Services.tsx";
import { useSearchParams } from "react-router-dom";
import Success from "../users/stripe/stripeSuccess.tsx";
import Failure from "../users/stripe/failureStripe.tsx";
// import PreloginHome from "../PreloginComponent/Layout/PreloginHome.tsx";
import WomensHealthDemo from "../components/layouts/womensHealthDemo.tsx";
import BusinessCards from "../PreloginComponent/OurVisionaries/BusinessCards.tsx";
import ManageCategories from "../users/settings/manageCategory/manageCategories.tsx";
import ManageSubscription from "../users/manageAccounts/manageSubscriptions/manageSubscription.tsx";
import AnimationDemoPage from "../components/layouts/Animationdemos.tsx";
import CustomAnimations from "../components/layouts/customAnimatons.tsx";
import MyVideos from "../users/myVideos/myVideos.tsx";
import CustomDemos from "../components/layouts/customDemos.tsx";
import Cookies from "js-cookie";
// import { Navigate } from "react-router-dom";
import PreloginHome2 from "../PreloginComponent/Layout/PreloginHome/PreloginHome.tsx";
import useGoogleAnalytics from "../hooks/useGoogleAnalaytics.ts";

function GoogleAnalyticsTracker() {
  useGoogleAnalytics()
  return null;
}


const AppRoutes: React.FC = () => {
  const [adminLoader, setAdminLoading] = useState(true);
  const domain = window.location.hostname;
  useEffect(() => {
    const timer = setTimeout(() => {
      setAdminLoading(false);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  if (adminLoader) {
    return <Loader />;
  }

  const ProtectedResetPassword = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");

    return token ? <ResetPassword /> : <Custom404 />;
  };

  const PublicRoute = ({ children }: { children: JSX.Element }) => {
    const token: any = Cookies.get("userToken");
    return token ? <Navigate to="/home" replace /> : children;
  };

  console.log("check route", domain !== LOCAL_SHORT_URL)

  return (
    <BrowserRouter>
      <GoogleAnalyticsTracker />
      <Routes>
        {/* Private Routes */}

        <>
          <Route
            path="/home"
            element={
              <PrivateRoute>
                <Layout>
                  <HomePage />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/share-animation"
            element={
              <PrivateRoute>
                <Layout>
                  <ShareAnimation />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="favorites"
            element={
              <PrivateRoute>
                <Layout>
                  <Favorites />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="my-videos"
            element={
              <PrivateRoute>
                <Layout>
                  <MyVideos />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/profile-setting"
            element={
              <PrivateRoute>
                <Layout>
                  <UserProfile />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/email-setting"
            element={
              <PrivateRoute>
                <Layout>
                  <DefaultMessageSetting />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/manage-favorites"
            element={
              <PrivateRoute>
                <Layout>
                  <ManageFavourites />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/manage-categories"
            element={
              <PrivateRoute>
                <Layout>
                  <ManageCategories />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="settings/manage-locations"
            element={
              <PrivateRoute>
                <Layout>
                  <ManageLocation />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="settings/manage-locations-class"
            element={
              <PrivateRoute>
                <Layout>
                  <ManageLocationsClass />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="settings/manage-users"
            element={
              <PrivateRoute>
                <Layout>
                  <ManagerUser />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="settings/manage-subscriptions"
            element={
              <PrivateRoute>
                <Layout>
                  <ManageSubscription />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="animationloop/loop-setting"
            element={
              <PrivateRoute>
                <Layout>
                  <LoopSetting />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="usageReports"
            element={
              <PrivateRoute>
                <Layout>
                  <UsageReport />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="shared-animation-report"
            element={
              <PrivateRoute>
                <Layout>
                  <SharedAnimationReport />
                </Layout>
              </PrivateRoute>
            }
          />
        </>

        {domain === LOCAL_SHORT_URL && (
          <>
            {/* Short code route */}
            <Route path="/:shortCode" element={<ShortURLAnimationViewnew />} />
          </>
        )}
        {/* Public Routes */}

        <>
          <Route
            path="/"
            element={
              <PublicRoute>
                <PreloginHome2 />
              </PublicRoute>
            }
          />
          <Route
            path="/old-landing"
            element={
              <PublicRoute>
                <DefaultLandingPage />
              </PublicRoute>
            }
          />
          <Route
            path="/shareDesign"
            element={
              <PublicRoute>
                <ShortURLAnimationViewnew />
              </PublicRoute>
            }
          />
          <Route
            path="/custom-animations"
            element={
              <PublicRoute>
                <CustomAnimations />
              </PublicRoute>
            }
          />
          <Route
            path="/ent"
            element={
              <PublicRoute>
                <EntVideoPage />
              </PublicRoute>
            }
          />
          <Route
            path="/demo"
            element={
              <PublicRoute>
                <AnimationDemoPage />
              </PublicRoute>
            }
          />
          <Route
            path="/demos"
            element={
              <PublicRoute>
                <CustomDemos />
              </PublicRoute>
            }
          />
          <Route
            path="/entdemo"
            element={
              <PublicRoute>
                <EntDemoPage />
              </PublicRoute>
            }
          />
          <Route
            path="/whdemo"
            element={
              <PublicRoute>
                <WomensHealthDemo />
              </PublicRoute>
            }
          />
          <Route
            path="/utahlegalvideo"
            element={
              <PublicRoute>
                <SpineStaticLegal />
              </PublicRoute>
            }
          />
          <Route
            path="/rejoni"
            element={
              <PublicRoute>
                <Rejoni />
              </PublicRoute>
            }
          />
          <Route
            path="/rejoni-presentation"
            element={
              <PublicRoute>
                <RejoniPresentation />
              </PublicRoute>
            }
          />
          <Route
            path="/contact-us-theme"
            element={
              <PublicRoute>
                <ContactThemeGenerate />
              </PublicRoute>
            }
          />
          {/* <Route path="/start-project" element={<PublicRoute><StartProjectGroupPage /></PublicRoute>} />
          <Route path="/sign-up" element={<PublicRoute><SignUp /></PublicRoute>} /> */}
          <Route
            path="/signup"
            element={
              <PublicRoute>
                <Signup />
              </PublicRoute>
            }
          />
          <Route
            path="/login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />
          {/* <Route path="/otp-verify" element={<PublicRoute><OtpVerify /></PublicRoute>} /> */}
          <Route path="/logout" element={<Logout />} />
          <Route
            path="/emailtemplate"
            element={
              <PublicRoute>
                <EmailTemplate />
              </PublicRoute>
            }
          />
          <Route
            path="/finalDelivery/liger"
            element={
              <PublicRoute>
                <LigerFinal />
              </PublicRoute>
            }
          />
          <Route
            path="/loopvideo"
            element={
              <PublicRoute>
                <PlayLoop />
              </PublicRoute>
            }
          />
          <Route path="/resetpassword" element={<ProtectedResetPassword />} />
          <Route
            path="/contactus"
            element={
              <PublicRoute>
                <PreloginContact />
              </PublicRoute>
            }
          />
          <Route
            path="/aboutus"
            element={
              <PublicRoute>
                <PreloginAboutUs />
              </PublicRoute>
            }
          />
          <Route
            path="/services"
            element={
              <PublicRoute>
                <PreloginServices />
              </PublicRoute>
            }
          />
          <Route path="/crani" element={<Crani />} />
          <Route path="/ent" element={<EntVideoPage />} />
          <Route path="/sealonix" element={<Sealonix />} />
          <Route path="/gutlab" element={<GutLab />} />
          <Route path="/liger" element={<Liger />} />
          <Route path="/payment-success" element={<Success />} />
          <Route path="/payment-cancel" element={<Failure />} />
          <Route path="/business-cards/:user" element={<BusinessCards />} />
          <Route
            path="/freetrial"
            element={
              <PublicRoute>
                <Signup />
              </PublicRoute>
            }
          />
        </>

        {/* Undefined Routes */}
        <>
          <Route path="/" element={<Custom404 />} />
        </>
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
